import React, { useContext, useState } from 'react';
//import P from 'prop-types';
import { useForm } from 'react-hook-form';
import { GlobalContext } from '../../contexts/HomeContext';
import { Produtos } from '../Produtos';
import { verificaDiasRestricao } from '../../utils/utils';
import './style.css';
//import { LabelForm } from '../LabelForm';
//import { InputText } from '../InputText';

const _categoriaDefault = {
  atualizado: 1,
  back_color: '0;100;0',
  categoria_ecommerce: '',
  codigo_operador: 1,
  datahora: '2021-12-16T14:32:35',
  dom: 1,
  ecommerce_subgrupo_principal: '',
  excluido: 0,
  fore_color: 'White',
  grupo: '',
  hora_final_dom: '23:59',
  hora_final_qua: '23:59',
  hora_final_qui: '23:59',
  hora_final_sab: '23:59',
  hora_final_seg: '23:59',
  hora_final_sex: '23:59',
  hora_final_ter: '23:59',
  hora_inicio_dom: '0:00',
  hora_inicio_qua: '0:00',
  hora_inicio_qui: '0:00',
  hora_inicio_sab: '0:00',
  hora_inicio_seg: '0:00',
  hora_inicio_sex: '0:00',
  hora_inicio_ter: '0:00',
  id: 138,
  idloja: 2,
  nome_operador: 'JAMES ROCHA',
  numero_cx: 12,
  ordem: 14,
  ordem_app: 9999,
  pendente_exportacao: 0,
  qua: 1,
  qui: 1,
  sab: 1,
  seg: 1,
  sex: 1,
  subgrupo: '',
  ter: 1,
};

export const Procura = () => {
  const { dadosApp } = useContext(GlobalContext);
  const [produtos, setProdutos] = useState();
  const { register, handleSubmit } = useForm();

  const handleValidForm = (form) => {
    if (form.procura.length > 0) {
      setProdutos(
        dadosApp.Cardapio.Produtos.filter((produto) => {
          return (
            produto.descricao.toLowerCase().includes(form.procura.toLowerCase()) &&
            produto.is_subitem_multpreco === false // filtra somente os produtos de montagem principal, mantendo a mesma regra da listagem
          );
        }),
      );
    } else {
      setProdutos([]);
    }
  };

  return (
    <div style={{ margin: '10px 10px 0 10px' }}>
      <form
        //onSubmit={handleSubmit(handleValidForm)}
        onChange={handleSubmit(handleValidForm)}
        className="modal-content-dialog padTop20 buscaSticky"
        style={{ borderTop: 0, padding: 0 }}
      >
        <div className="form-group" style={{ marginBottom: '25px' }}>
          {/* <LabelForm text={'Digite o nome do produto'} /> */}
          <input
            type="text"
            placeholder={'ex. coca cola'}
            className="form-control"
            {...register('procura')}
            style={{ marginTop: 15 }}
          />
          <i className="material-icons" style={{ top: '19px' }}>
            search
          </i>
        </div>

        {/* <div className="form-container">
          <input
            type="text"
            placeholder="ex. coca cola"
            className="inputProcura {
"
            {...register('procura2')}
          />
        </div> */}
      </form>
      <div style={{ margin: '20px 5px 30px', textAlign: 'center', minHeight: 333 }}>
        <div className="row">
          <div className="col-lg-6" style={{ textAlign: 'left' }}>
            {produtos?.map((produto, index) => {
              const _categoria = dadosApp.Cardapio.Categorias.filter((item) => {
                if (produto.categoria_ecommerce !== '') return item.categoria_ecommerce === produto.categoria_ecommerce;
                return item.subgrupo === produto.subgrupo;
              });
              if (_categoria.length === 0) _categoria.push(_categoriaDefault);
              const diasRestricao = verificaDiasRestricao(dadosApp.DiaSemana, _categoria[0]);
              if (dadosApp.TipoApp === 'MESA') diasRestricao.podeVender = true;
              return <Produtos key={index} diasRestricao={diasRestricao} item={produto} isSearch={true} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

// Procura.propTypes = {
//   param: P.object,
// };
